<sk-modal-content [title]="'label.Translations' | translate"
                  [cancelBtnText]="'label.Close'"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    @for (language of languages; track language) {
      <div>
        <sk-text
          [attr.data-test]="'translations-' + language.name"
          [label]="'label.' + language.name | translate"
          [(ngModel)]="translations[language.name]"
        ></sk-text>
      </div>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Save' | translate"
      data-test="modal-footer-confirm-button"
      (click)="accept()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>

</sk-modal-content>
